import { Group, type GroupProps } from "@mantine/core";
import { IconHelpCircle } from "@tabler/icons-react";
import type { OptiSupportEndpoints } from "../../urls";
import urls from "../../urls";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import "./OptiSupportHelpLink.scss";

interface OptiSupportHelpLinkProps extends GroupProps {
  optiSupportEndpoint: OptiSupportEndpoints;
  text: string;
}

function OptiSupportHelpLink({
  optiSupportEndpoint,
  text,
  ...groupProps
}: OptiSupportHelpLinkProps) {
  return (
    <Group
      {...groupProps}
      className="OptiSupportHelpLink"
      gap="6px"
      justify="flex-end"
      wrap="nowrap"
    >
      <IconHelpCircle strokeWidth={1} />
      <AnchorLink href={urls.optiSupport(optiSupportEndpoint)} nowrap>
        {text}
      </AnchorLink>
    </Group>
  );
}

export { OptiSupportHelpLink, OptiSupportHelpLinkProps };
